import { render, staticRenderFns } from "./RespiteEditor.vue?vue&type=template&id=5919f2f4&"
import script from "./RespiteEditor.vue?vue&type=script&lang=js&"
export * from "./RespiteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports